import { render, staticRenderFns } from "./AddAdmin.vue?vue&type=template&id=b69d238a"
import script from "./AddAdmin.vue?vue&type=script&lang=js"
export * from "./AddAdmin.vue?vue&type=script&lang=js"
import style0 from "./AddAdmin.vue?vue&type=style&index=0&id=b69d238a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports